module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("j1Myr"))).then(() => parcelRequire('1iHdE'));